import './Accordion.scss'

import React, { useState, useCallback } from 'react'
import classNames from 'classnames'

interface Props {
  title: string
  contents: string
}

export default function Accordion({ title, contents }: Props) {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = useCallback(() => setIsOpen(prevIsOpen => !prevIsOpen), [])

  return (
    <div
      className={classNames('Accordion', {
        'Accordion--open': isOpen,
      })}
    >
      <div
        className={classNames('Accordion__titleWrapper', {
          'Accordion__titleWrapper--open': isOpen,
        })}
        onClick={handleClick}
      >
        <div className="Accordion__titleWrapper__question">
          <span>Q</span>
          <span className="Accordion__titleWrapper__title">{title}</span>
        </div>
      </div>
      <div className="Accordion__contents">
        <div
          dangerouslySetInnerHTML={{
            __html: contents,
          }}
        />
      </div>
    </div>
  )
}
